import { ActionTypes } from "../constants/action-types";
import { createAction } from "redux-actions";
import {
  activeTeamMember,
  enableAdminTeamMember,
  getBuildInfo,
  getTeamMembers,
  getTeamPipelines,
  removeTeamMember,
} from "../api/TenantApi";

const api = {
  [ActionTypes.getBuildInfo]: () => getBuildInfo(),
  [ActionTypes.getTeamMembers]: () => getTeamMembers(),
  [ActionTypes.activeTeamMember]: (accountId) => activeTeamMember(accountId),
  [ActionTypes.enableAdminTeamMember]: (accountId) => enableAdminTeamMember(accountId),
  [ActionTypes.removeTeamMember]: (accountId) => removeTeamMember(accountId),
  [ActionTypes.getTeamPipelines]: () => getTeamPipelines(),
};

const actions: any = { ...api };

Object.keys(actions).forEach((type) => {
  actions[type] = createAction(type, actions[type]);
});

export default actions;
